<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.work_classes.hasTabToShow" class="tab" data-cy="tab-work_classes">
              <h2 [className]="tabs.work_classes.active? 'active': ''" (click)="tabs.work_classes.activate()">{{tabs.work_classes.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-work_classes_grid *ngIf="tabs.work_classes.active"
              #$tabs_work_classes
              ($refreshEvent)="refresh(false, false, '$tabs_work_classes')">
              </FootprintManager-work_classes_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>